import { Form, Input } from "antd"



const CategoryForm = () => {



  return (
    <>
        <Form.Item
              name="name"
              label="name"
              rules={[
                {
                  required: true,
                  message: "Please fill this field",
                },
              ]}
            >
              <Input placeholder="name" />
            </Form.Item>
    </>
  )
}

export default CategoryForm